<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15,7C14.45,7,14,7.45,14,8C14,8,14,8.59,14,8.59C14,8.59,9.71,4.29,9.71,4.29C9.53,4.11,9.28,4,9,4C8.84,4,8.69,4.05,8.56,4.11C8.56,4.11,8.56,4.1,8.56,4.1C8.56,4.1,5,5.88,5,5.88C5,5.88,1.45,4.11,1.45,4.11C1.45,4.11,1.45,4.12,1.45,4.12C1.31,4.05,1.16,4,1,4C0.45,4,0,4.45,0,5C0,5.39,0.23,5.72,0.56,5.89C0.56,5.89,0.56,5.9,0.56,5.9C0.56,5.9,4.56,7.9,4.56,7.9C4.56,7.9,4.56,7.890000000000001,4.56,7.890000000000001C4.69,7.95,4.84,8,5,8C5.16,8,5.31,7.95,5.44,7.890000000000001C5.44,7.890000000000001,5.44,7.9,5.44,7.9C5.44,7.9,8.8,6.220000000000001,8.8,6.220000000000001C8.8,6.220000000000001,12.59,10,12.59,10C12.59,10,12,10,12,10C11.45,10,11,10.45,11,11C11,11.55,11.45,12,12,12C12,12,15,12,15,12C15.55,12,16,11.55,16,11C16,11,16,8,16,8C16,7.45,15.55,7,15,7C15,7,15,7,15,7Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'TrendingDown',
} as DefineComponent
</script>
